import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "Store/configureStore";

export const subscriptionAlertStateSelector = (state: RootState) =>
  state.subscriptionAlert;

export const subscriptionAlertInfoSelector = createSelector(
  subscriptionAlertStateSelector,
  (
    _: RootState,
    params: { organizationDescriptionId: string; subscriptionId: string }
  ) => params,
  (subscriptionAlertState, { organizationDescriptionId, subscriptionId }) =>
    subscriptionAlertState.data?.[organizationDescriptionId]?.[
      subscriptionId
    ] ?? { alert: undefined, loading: false, error: undefined }
);
